/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MfaFlowResponse } from '../models/MfaFlowResponse';
import type { StartEscalationAuthRequest } from '../models/StartEscalationAuthRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EscalationService {
    /**
     * Start Escalation Authentication
     * Start authentication flow for a pending escalation request. Forces fresh authentication regardless of cookies.
     * @param requestBody
     * @returns MfaFlowResponse Successful Response
     * @throws ApiError
     */
    public static startEscalationAuthentication(
        requestBody: StartEscalationAuthRequest,
    ): CancelablePromise<MfaFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/escalation/start-authentication',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
